import { MapPin, Mail, Phone, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-neutral-950 text-neutral-400">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="font-display font-bold text-white text-xl tracking-tight">Künzler &amp; Sauber AG</div>
          <p className="mt-4 text-sm leading-relaxed max-w-xs">
            Ihr persönlicher KIA Partner für Firmenkunden und Flotten im Zürcher Oberland.
          </p>
        </div>
        <div className="text-sm space-y-3">
          <div className="text-xs uppercase tracking-[0.25em] text-neutral-500 font-semibold mb-4">Kontakt</div>
          <div className="flex items-start gap-3">
            <MapPin size={15} className="mt-0.5 shrink-0" />
            <span>Künzler &amp; Sauber AG<br />Heuweidlistrasse, 8340 Hinwil</span>
          </div>
          <div className="flex items-center gap-3">
            <Phone size={15} className="shrink-0" />
            <a href="tel:+41449389090" className="hover:text-white transition-colors" data-testid="footer-phone">044 938 90 90</a>
          </div>
          <div className="flex items-center gap-3">
            <Mail size={15} className="shrink-0" />
            <a href="mailto:info@auto-hinwil.ch" className="hover:text-white transition-colors" data-testid="footer-email">info@auto-hinwil.ch</a>
          </div>
          <div className="flex items-center gap-3">
            <Globe size={15} className="shrink-0" />
            <a href="https://www.auto-center-hinwil.ch" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-testid="footer-website">www.auto-center-hinwil.ch</a>
          </div>
        </div>
        <div className="text-sm space-y-3">
          <div className="text-xs uppercase tracking-[0.25em] text-neutral-500 font-semibold mb-4">Rechtliches</div>
          <p className="text-xs leading-relaxed text-neutral-500">
            Alle Preise sind unverbindliche Listenpreise in CHF gemäss KIA Schweiz. Preisänderungen und Irrtümer vorbehalten.
            KIA ist eine eingetragene Marke der Kia Corporation. Künzler &amp; Sauber AG ist ein unabhängiger KIA Handelspartner.
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs" data-testid="footer-legal-links">
            <a href="https://www.auto-center-hinwil.ch/impressum" target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-white transition-colors" data-testid="footer-impressum">Impressum</a>
            <a href="https://www.auto-center-hinwil.ch/datenschutz" target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-white transition-colors" data-testid="footer-datenschutz">Datenschutz</a>
            <a href="https://www.auto-center-hinwil.ch/agb" target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-white transition-colors" data-testid="footer-agb">AGB</a>
          </div>
          <a href="/admin" className="inline-block text-xs text-neutral-600 hover:text-white transition-colors" data-testid="footer-admin-link">
            Admin-Login
          </a>
        </div>
      </div>
      <div className="border-t border-neutral-800 py-6 text-center text-xs text-neutral-600">
        © {new Date().getFullYear()} Künzler &amp; Sauber AG – KIA Firmenkunden
      </div>
    </footer>
  );
}
